import React from 'react';
import PropTypes from 'prop-types';
import { EditorView } from 'prosemirror-view';
import ReactDOM from 'react-dom';
import { Popover, PopoverBody } from 'reactstrap';

import { UserAvatar } from '@techchange/filestack';

import { mentionViewPluginKey } from '../plugins/mentionView';

const propTypes = {

	/**
	 * The users that are available to at-mention.
	 *
	 * NOTE: Map from userID -> user, enrollment, and avatar data.
	 */
	mentionUsers: PropTypes.objectOf(PropTypes.shape({

		/**
		 * The user id.
		 */
		id: PropTypes.string.isRequired,

		/**
		 * The user display name.
		 */
		display_name: PropTypes.string.isRequired,

		/**
		 * An array of avatars (profile pictures).
		 */
		avatars: PropTypes.arrayOf(PropTypes.shape({

			image: PropTypes.string,

			signature: PropTypes.string,

			policy: PropTypes.string,

		})).isRequired,

	})).isRequired,

	/**
	 * The prosemirror editor view object.
	 */
	editorView: PropTypes.instanceOf(EditorView).isRequired,

};

const UserTooltip = (props) => {

	const { mentionUsers, editorView } = props;

	// Get plugin state from current view
	const pluginState = mentionViewPluginKey.getState(editorView.state);
	const { mentionNode, mentionDOM } = pluginState;

	if (mentionUsers && mentionNode && mentionDOM) {

		const userId = mentionNode.attrs?.id;

		const user = mentionUsers[userId];

		if (user) {

			return (
				<Popover
					id="user-mention-tooltip"
					className="tc-pm-user-tooltip"
					role="tooltip"
					target={mentionDOM}
					placement="top"
					fade={false}
					isOpen>
					<PopoverBody className="d-flex align-items-center">
						<UserAvatar
							user={user}
							size="50"
							title={user.display_name}
							rounded />
						<div className="p-2 align-items-center">
							<div className="font-weight-bold pr-2">
								{user.display_name}
							</div>
						</div>
					</PopoverBody>
				</Popover>
			);

		}

	}

	return <div />;

};

UserTooltip.propTypes = propTypes;

export default UserTooltip;
